import styled from 'styled-components'

import { PlusIcon } from '@blade/ui-kit'

type PlusFloatingButtonProps = React.HTMLAttributes<HTMLDivElement>

export const PlusFloatingButton: React.FC<PlusFloatingButtonProps> = (
  props,
) => {
  return (
    <Root {...props}>
      <PlusIcon size={10} />
    </Root>
  )
}

const Root = styled.div`
  margin-top: 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--primary-9);
  transition: background 0.15s ease-in-out;
  cursor: pointer;
  &:hover {
    background: var(--primary-10);
  }
`
